/**
 * SLO Space – Ritual for Booster section
 * Icon scroll rotation (same as intro) + bracket fly-in animation (same as card-square)
 */
(function() {
  const icons = [];
  document.querySelectorAll('.ritual-for-booster__icon').forEach(function(iconWrapper) {
    const icon = iconWrapper.querySelector('img, svg');
    if (icon) icons.push(icon);
  });
  if (icons.length > 0) {
    let ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(function() {
          const deg = window.scrollY * 0.08;
          icons.forEach(function(icon) { icon.style.transform = 'rotate(' + deg + 'deg)'; });
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  function initBracketAnimation() {
    document.querySelectorAll('.ritual-for-booster').forEach(function(section) {
      if (section.classList.contains('ritual-for-booster--animated')) return;
      const observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('ritual-for-booster--animated');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.2 });
      observer.observe(section);
    });
  }
  initBracketAnimation();

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function() {
      initBracketAnimation();
    });
  }
})();
